import React from "react";
import Style from "../components/components.less";

const props = () => {
  return <div className={Style.box}>{props.children}</div>;
};
export default props
